import { useCallback, useMemo } from "react";
import { queries } from "../../shared/queries";
import { usedConnectorsForSpace } from "../lib/usedSuppliersForSpace";
import { useQuery } from "./useQuery";

// Resolves the connectors a space uses (workflow-referenced + git remote) on the
// client, mirroring the server's spaceAppEdgesZql. The connector rows already
// carry their `.usages`; the only missing datum is workflow -> space, fetched here.
export function useSpaceUsedSuppliers<
  T extends { usages?: readonly { type: string; refId: string }[] },
>(connectors: readonly T[]) {
  const workflowIds = useMemo(
    () => [
      ...new Set(
        connectors.flatMap((c) =>
          (c.usages ?? [])
            .filter((u) => u.type === "workflow_slug")
            .map((u) => u.refId)
        )
      ),
    ],
    [connectors]
  );
  const [workflows] = useQuery(queries.workflowSpaceMap({ workflowIds }));
  const workflowSpaceById = useMemo(
    () => new Map(workflows.map((w) => [w.id, w.spaceId] as const)),
    [workflows]
  );
  const usedConnectors = useCallback(
    (spaceId: string) =>
      usedConnectorsForSpace(spaceId, connectors, workflowSpaceById),
    [connectors, workflowSpaceById]
  );
  return { usedConnectorsForSpace: usedConnectors };
}
